import { ToitEnPenteConfigurationState } from "@iko-design-center/shared";
import React, { ReactNode, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { useApplication } from "../../../store/application/hooks";
import { ApplicationTypes } from "../../../store/application/store";
import { Home } from "../Home";
import { useToitEnPente } from "../../../store/toit-en-pente/hooks";
import { useRoutes } from "../../../store/routes/hooks";
import { useQueryParams } from "../../../store/query/toit-en-pente.hooks";

export const Guard = (props: { children: ReactNode }) => {
  return (
    <>
      <ResetStateGuard>
        <ValidStateGuard>{props.children}</ValidStateGuard>
      </ResetStateGuard>
    </>
  );
};

// This makes sure, that when a user navigates backwards,
// either via the Navbar or via the browser back button,
// the state is reset. This so the user can reselect any options.
const ResetStateGuard = (props: { children: ReactNode }) => {
  const {
    resetConfiguration,
    resetConfigurationToClimate,
    resetConfigurationToStructure,
    resetConfigurationToRainCover,
  } = useToitEnPente();
  const { Routes } = useRoutes() as any;
  const location = useLocation();
  const routeHome = Routes.HOME;
  const routeToitEnPenteStructure = Routes.TOIT_EN_PENTE_1_STRUCTURE
  const routeToitEnPenteRainCover = Routes.TOIT_EN_PENTE_2_RAIN_COVER
  const routeToitEnPenteOverview = Routes.TOIT_EN_PENTE_3_OVERVIEW

  useEffect(() => {
    switch (location.pathname) {
      case routeHome:
        resetConfiguration();
        break;
      case routeToitEnPenteStructure:
        resetConfigurationToStructure();
        break;
      case routeToitEnPenteRainCover:
        resetConfigurationToRainCover();
        break;
      case routeToitEnPenteOverview:
        break;
    }
  }, [
    resetConfiguration,
    resetConfigurationToClimate,
    resetConfigurationToStructure,
    resetConfigurationToRainCover,
    location.pathname,
    routeHome,
    routeToitEnPenteStructure,
    routeToitEnPenteRainCover,
    routeToitEnPenteOverview,
  ]);

  return <>{props.children}</>;
};

// When a user refreshes the screen on let's say the OverviewPage,
// No state will be present in Redux, thus 'cannot read of undefined's will pop up.
// This prevents that.
const ValidStateGuard = (props: { children: ReactNode }) => {
  const { directLink, setDirectLink, setApplicationType, applicationType } = useApplication();
  const location = useLocation();
  const { redirectBasedOnQueryParams } = useQueryParams()
  const { configurationState } = useToitEnPente();
  const { Routes } = useRoutes() as any;

  const history = useHistory();

  const valid = checkValidStateForRoute(
    applicationType,
    configurationState,
    location.pathname,
    Routes
  );

  useEffect(() => {
    if (!valid) {
      if (!directLink) {
        setDirectLink(true)
        setApplicationType(ApplicationTypes.TOIT_EN_PENTE);
        redirectBasedOnQueryParams()
      } else {
        history.push(Routes.HOME);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valid, setApplicationType, history, setDirectLink, directLink])

  return valid ? <>{props.children}</> : <Home />;
};

function checkValidStateForRoute(
  applicationType: ApplicationTypes | null,
  configurationState: ToitEnPenteConfigurationState,
  route: string,
  Routes: any
): boolean | undefined {
  const {
    toitInsulation,
    toitClimate,
    toitStructure,
  } = configurationState;

  const applicationTypeValid = applicationType !== null;
  const toitInsulationValid = toitInsulation.type !== null;
  const toitClimateValid = toitClimate.type !== null;
  const toitStructureValid = toitStructure.type !== null;

  switch (route) {
    case Routes.TOIT_EN_PENTE_3_OVERVIEW:
      return toitInsulationValid && toitClimateValid && toitStructureValid

    case Routes.TOIT_EN_PENTE_2_RAIN_COVER:
      return toitInsulationValid && toitClimateValid && toitStructureValid;

    case Routes.TOIT_EN_PENTE_1_STRUCTURE:
      return applicationTypeValid;

    case Routes.HOME:
      return true;
  }
}
